import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

export const $InlineCol = styled(Col)`
  display: inline-flex;
`;
